import { ImageViewer } from './ImageViewer'
import { PdfViewer } from './PdfViewer'
import './index.styles.css'
interface Props {
  url: string
  contentType: string
  fileId?: string | null
  filename?: string
}

export const ExpenseFileViewer = ({ url, contentType, fileId, filename }: Props) => {
  const isPdf = contentType === 'application/pdf'
  const isImage = contentType.startsWith('image/')

  return (
    <>
      {isPdf && <PdfViewer url={url} initialScale="page-fit" fileId={fileId} filename={filename} />}

      {isImage && <ImageViewer url={url} fileId={fileId} />}
    </>
  )
}
